'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { SORT_FIELD_ORDER } from '../../../constants/search';
import { getTranslatedSortText } from '../../../utils/i18n';
import FilterDrilldownPanelWrapper from './FilterDrilldownPanelWrapper';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import MobilePanelNavItem from 'ecosystem-marketplace-core/js/components/mobile/MobilePanelNavItem';
import MobilePanel from 'ecosystem-marketplace-core/js/components/mobile/MobilePanel';
import * as SortField from '../../../constants/search/SortField';
const textPath = 'ecosystem-marketplace-solutions-ui.storefront.results.sort';
const PANEL_KEY = 'sort';

const SortPanel = ({
  activePanelIds,
  activeSort,
  applyFilters,
  clickFilter,
  filters,
  onPanelClose,
  onSortChange
}) => {
  const sortOptions = useMemo(() => {
    return SORT_FIELD_ORDER.filter(sort => sort !== SortField.RELEVANCE_DESC || filters.search).map(sort => {
      return {
        text: getTranslatedSortText(sort),
        value: sort
      };
    });
  }, [filters]);
  return /*#__PURE__*/_jsx(MobilePanelNavItem, {
    onClickItem: clickFilter,
    title: getTranslatedSortText(activeSort),
    itemId: PANEL_KEY,
    children: /*#__PURE__*/_jsx(MobilePanel, {
      open: activePanelIds && activePanelIds.indexOf(PANEL_KEY) !== -1,
      align: "right",
      children: /*#__PURE__*/_jsx(FilterDrilldownPanelWrapper, {
        applyFilters: applyFilters,
        onPanelClose: () => onPanelClose(PANEL_KEY),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${textPath}.label`
        }),
        children: /*#__PURE__*/_jsx(FilterToggleGroup, {
          ariaLabel: unescapedText(`${textPath}.label`),
          inputClassName: "m-bottom-2",
          name: "sort-toggle-group",
          onChange: ({
            target: {
              value: sort
            }
          }) => {
            onSortChange(sort);
          },
          options: sortOptions,
          value: activeSort
        })
      })
    })
  });
};

SortPanel.propTypes = {
  activePanelIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  activeSort: PropTypes.string,
  applyFilters: PropTypes.func.isRequired,
  clickFilter: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  onPanelClose: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired
};
export default SortPanel;